import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

export default function Footer() {
  const location = useLocation();
  const isContactPage = location.pathname === "/contact";
  const [submitted, setSubmitted] = useState(false);
  const form = useRef();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [msgDialog, setMsgDialog] = useState("");
  const [titleDialog, setTitleDialog] = useState("");
  const isLargeScreen = useMediaQuery('(min-width: 1024px)');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("form --> " + form.current.elements);
    setSubmitted(true);

    if (name === "" || !isValidEmail(email) || message === "") {
      return;
    }

    emailjs
      .sendForm(
        "service_ocs1sre",
        "template_9hfdqgo",
        form.current,
        "xtaAsPF6g9fm5Ah63"
      )
      .then(
        (result) => {
          console.log(result.text);
          setSubmitted(false);
          setEmail("");
          setName("");
          setMessage("");
          setOpenDialog(true);
          setTitleDialog("Email Sent!!");
          setMsgDialog(
            "Thank you for providing your details. Our team at Everest Apps will contact you soon!"
          );
        },
        (error) => {
          console.log(error.text);
          setTitleDialog("Email sending failed.");
          setMsgDialog(error.text);
          setOpenDialog(true);
        }
      );
  };

  function isValidEmail(_email) {
    return /\S+@\S+\.\S+/.test(_email);
  }

  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <div className={` ${isContactPage ? "min-h-screen" : ""} bg-[#00101D] w-full px-4 overflow-hidden flex flex-col lg:flex-row lg:gap-10`}>
      <div className={`${isContactPage ? "min-h-screen mt-[100px]" : ""} bg-[#002F54] text-white py-12 lg:py-20 pb-36 md:pb-20 lg:pb-32 px-4 lg:px-24 rounded-t-3xl mx-auto max-w-7xl`}>
        <div className="flex h-full flex-col lg:flex-row lg:gap-20  lg:items-stretch text-center lg:justify-between">
          <div className={`flex flex-col items-center lg:items-start lg:text-start w-full text-center gap-12 h-auto flex-1 ${isLargeScreen && !isContactPage ? "justify-between":""}`}>
            <div>
              <p className="text-lg md:text-2xl lg:text-4xl font-extrabold">
                Trusted by
              </p>
              <p className="mt-2 mx-auto text-lg md:text-2xl lg:text-4xl font-light">
                schools, charities, and startup founders across Australia and
                beyond.
              </p>
            </div>
            <div className="flex items-center justify-center">
              <Link to="/" className="lg:flex items-center hidden">
                <img
                  src="/assets/logo.svg"
                  alt="Everest Apps Logo"
                  className="h-12 lg:h-28 w-auto mr-2"
                />
              </Link>
            </div>
          </div>

          <form
            ref={form}
            onSubmit={handleSubmit}
            className={`${isLargeScreen && isContactPage ? "flex flex-col gap-4 md:gap-2 lg:gap-[20px] lg:py-0 lg:px-0 h-auto flex-1":"flex flex-col gap-4 md:gap-2 lg:gap-0 justify-between lg:py-0 lg:px-0 h-auto flex-1"}`}
          >
            <h2 className="text-2xl md:text-3xl lg:text-4xl text-center lg:text-start font-medium">
              Book a Free Discovery Call
            </h2>
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="w-full p-4 rounded-xl bg-black bg-opacity-25 placeholder-white focus:outline-none text-lg"
              error={submitted && name === ""}
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full p-4 rounded-xl bg-black bg-opacity-25 placeholder-white focus:outline-none text-lg"
              error={submitted && email === ""}
            />
            <textarea
              name="message"
              placeholder="Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              rows="1"
              error={submitted && message === ""}
              className="w-full p-4 rounded-xl bg-black bg-opacity-25 placeholder-white focus:outline-none text-lg"
            />
            <button
              type="submit"
              className="btn w-full rounded-xl py-3 text-lg font-medium"
            >
              Let's Chat
            </button>
            <p className="text-center font-medium text-lg max-w-[10rem] md:max-w-full mx-auto">
              or email us at{" "}
              <a href="mailto:hello@everestapps.io" className="">
                hello@everestapps.io
              </a>
            </p>
            {/* {submitted && (
              <p className="text-green-400 text-center">
                Thanks! We'll be in touch soon.
              </p>
            )} */}
          </form>
        </div>
        <p className="text-sm md:text-lg text-center text-gray-500 mt-16">
          copyright Everest Apps
        </p>
      </div>

      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{titleDialog}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {msgDialog}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
